<template>
  <div class="local minbox">
    <!-- 头部通用区域 -->
    <div class="boxContent">
      <!-- 头部导航区域 -->
      <div class="navbar ">
        <Navbar :itemIndex="activeIndex" />
      </div>
    </div>
    <!--    banner-->
    <section class="solution-banner">
      <div class="main-container">
        <div class="inner">
          <div class="title1">
            国家产融合作平台
          </div>
          <div class="title2">
            National Platform for lnduustry-finance Cooperation
          </div>
        </div>
      </div>
    </section>

    <section class="main-container">
      <div class="section-name">
        国家产融合作平台
      </div>

      <div class="section-des txt-center">
        2020年7月份，华炫鼎盛在工业和信息化部，以及中国信息通信研究院、中国工业互联网研究院、工业文化发展中心、赛迪研究院等单位的指导和支持下，承建的国家产融合作平台成功上线。平台依托工信部政策资源、数据资源、产业资源，利用互联网+、大数据等新兴技术，打通产融信息对接渠道，实现政策管理与公共服务线上化、数据分析与信息对接智能化、实现政策管理与公司共服务线上化、数据分析与信息对接智能化、产融交流与多方合作生态化，助力国家实体经济转型升级。
      </div>
      <div class="show-img">
        <img src="../../assets/solutionImg/cooperation1.png" alt="">
        <img src="../../assets/solutionImg/cooperation2.png" alt="">
        <img src="../../assets/solutionImg/cooperation3.png" alt="">
        <img src="../../assets/solutionImg/cooperation4.png" alt="">
      </div>
    </section>

    <!-- 底部公共区域 -->
    <section class="boxContentFooter">
      <FooterAll />
    </section>
  </div>
</template>
<script>
  import Navbar from '../../components/public/NavBar'
  import FooterAll from '../../components/public/footerAll'
  export default {
    data(){
      return{
        activeIndex: '1'
      }
    },
    components: {
      Navbar,
      FooterAll,
    },
  }
</script>
<style lang="scss" scoped>
  @import "./solution.scss";
</style>
<style lang="scss" scoped>
  .show-img{
    width: 1114px;
    margin: 60px auto 0px;
    img{
      width: 100%;
      height: 325px;
      margin-bottom: 60px;
    }
  }
  .local{
    .solution-banner{
      background-image: url("../../assets/solutionImg/cooperation_banner.png");
    }
  }
</style>
